import React from "react";
import ContainerDimensions from "react-container-dimensions";
import styled, { keyframes } from "styled-components";
import { prop } from "styled-tools";

import HaloChart from "components/HaloChart";
import Icon from "components/Icon";

/*
 * Styles
 */

const Caret = styled.div`
  bottom: 1rem;
  color: ${prop("theme.colors.grayT")};
  display: none;
  font-size: ${prop("theme.scale.up3")};
  left: 50%;
  margin-left: -2rem;
  position: absolute;
  text-align: center;
  width: 4rem;
  @media (min-width: 50em) and (min-height: 58em) {
    display: block;
  }
`;

const enterContainer = keyframes`
  from {
    opacity: 0;
  }
`;

const Container = styled.div`
  align-items: center;
  animation: ${enterContainer} 1800ms ease 100ms backwards;
  box-sizing: border-box;
  display: flex;
  min-height: 100vw;
  padding: 4rem 0;
  position: relative;
  overflow: hidden;
  @media (min-width: 35em) {
    min-height: 40rem;
  }
  @media (min-width: 50em) and (min-height: 45em) {
    min-height: calc(100vh - 4.8rem);
  }
`;

const Chart = styled.div`
  align-items: center;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  margin: 2rem 0;
  position: absolute;
  right: 0;
  top: 0;
  @media (min-width: 30em) {
    margin: 2rem;
  }
`;

const Content = styled.div`
  margin: 4rem auto;
  max-width: 20rem;
  position: relative;
  text-align: center;
  z-index: 10;
  h1 {
    color: ${prop("theme.colors.grayS")};
    font-family: ${prop("theme.fonts.heading")};
    font-size: ${prop("theme.scale.up3")};
    line-height: 2rem;
    margin: 0 0 2rem;
  }
  span {
    color: ${prop("theme.colors.gray")};
    display: block;
    font-size: ${prop("theme.scale.down4")};
    text-transform: uppercase;
    &:last-of-type {
      position: relative;
      &::after,
      &::before {
        background: ${prop("theme.colors.grayT")};
        content: "";
        height: 1px;
        position: absolute;
        top: 50%;
        width: calc(50% - 1.2rem);
      }
      &::after {
        right: 0;
      }
      &::before {
        left: 0;
      }
    }
  }
  @media (min-width: 25em) {
    h1 {
      font-size: ${prop("theme.scale.up4")};
      line-height: 2.4rem;
    }
    span {
      font-size: ${prop("theme.scale.down5")};
    }
  }
  @media (min-width: 35em) {
    h1 {
      font-size: ${prop("theme.scale.up6")};
      line-height: 3.2rem;
    }
    span {
      font-size: ${prop("theme.scale.down7")};
    }
  }
`;

/*
 * Component
 */

const Title = (props) => (
  <Container>
    {props.responses.length > 0 && (
      <Chart>
        <ContainerDimensions>
          <HaloChart
            statements={props.statements}
            responses={props.responses}
          />
        </ContainerDimensions>
      </Chart>
    )}
    <Content>
      <h1>
        <span>The</span>
        State
        <span>of</span>
        Theology
      </h1>
    </Content>

    <Caret>
      <Icon id="down" title="Down" />
    </Caret>
  </Container>
);

export default Title;
